export const translations = {
	'Only data sources can be added to the canvas for now': {},
	'View {0}': {},
	'New view': {},
	'Delete current view': {},
	'Table': {},
	'No element selected': {},
	'{0} elements selected': {},
	'Name': {},
	'X': {},
	'Y': {},
	'Width': {},
	'Height': {},
	'W': {},
	'H': {},
	'Hidden on this view': {},
	'Hide on this view': {},
	'Show on this view': {},
	'Data': {},
	'Reset view': {},
	'Default': {},
	'Undo': {},
	'Canvas': {},
	'Grid size': {},
	'Hide dots': {},
	'Palette': {},
	'Dashboard palette': {},
	"When you pick a color for an element (for example, the background of a widget) and choose a color from the dashboard palette instead of a specific color, you don't actually set the color — you link the element to that palette slot. If you later change the color of that slot, all linked elements will be updated as well. You can change your dashboard palette here by picking colors one by one.":
		{},
	'Replace palette with...': {},
	'Datasource': {},
	'Edit datasource': {},
	'Color': {},
	'Appearance': {},
	'Drop a datasource here': {},
	'View mode': {},
	'To designer': {},
	'Copy': {},
	'Paste': {},
	'Select all': {},
	'Move left': {},
	'Move right': {},
	'Move up': {},
	'Move down': {},
	'Shapes': {},
	'Layers': {},
	'To front': {},
	'To back': {},
	'No elements': {},
	'Rectangle': {},
	'Ellipse': {},
	'Triangle': {},
	'Diamond': {},
	'Arrow': {},
	'Star': {},
	'Bold': {},
	'Text color': {},
	'Horizontal': {},
	'Vertical': {},
	'Left': {},
	'Right': {},
	'Redo': {},
	'Layout': {},
	'Rotate': {},
	'Opacity': {},
	'Reset': {},
	'Background': {},
	'Radius': {},
	'Effects': {},
	'None': {},
	'Drop shadow': {},
	'Add source': {},
	'All points': {},
	'Average line': {},
	'Bar': {},
	'Circle': {},
	'Dashed': {},
	'Dial': {},
	'Donut': {},
	'Dotted': {},
	'Fade the area out': {},
	'Gauge': {},
	'Horizontal bars': {},
	'Keep the shape': {},
	'Line style': {},
	'Line width': {},
	'Maximum': {},
	'Maximum point': {},
	'Minimum': {},
	'Minimum point': {},
	'No steps': {},
	'Pie': {},
	'Point shape': {},
	'Point size': {},
	'Remove source': {},
	'Scale from': {},
	'Scale to': {},
	'Show points': {},
	'Smooth': {},
	'Solid': {},
	'Square': {},
	'Stacked': {},
	'Step at end': {},
	'Step at start': {},
	'Step in the middle': {},
	'Steps': {},
	'Sampling': {},
	'Widgets': {},
	'Add {0}': {},
	'Show it as': {},
	'The widget already shows data.': {},
	'Replace what it shows': {},
	'Add to what it shows': {},
	'Back': {},
	'Done': {},
	'Group': {},
	'Ungroup': {},
	'Group {0}': {},
	'Source {0}': {},
	'Show header': {},
	'Lock': {},
	'Unlock': {},
	'Y axis': {},
	'Chart type': {},
	'Pie of latest values': {},
	'Series': {},
	'Latest values': {},
	'Add': {},
	'Border': {},
	'Combined': {},
	'Variables': {},
	'Variable': {},
	'New variable': {},
	'Edit variable': {},
	'Delete the variable?': {},
	'No variables yet': {},
	'From data': {},
	'Column': {},
	'Compare the value': {},
	'Current value: {0}': {},
	'Condition on the variables': {},
	'Another variable has this name': {},
	'The first row the datasource gives is taken; its filter and sorting decide which one': {},
	'Add a variable in the Variables window to style the element by it': {},
	'How the element looks while a variable meets a condition': {},
	'Hide': {},
	'Switch': {},
	'Controls': {},
	'Dropdown': {},
	'Label column': {},
	'Value column': {},
	'Choice': {},
	'Segmented': {},
	'Radio': {},
	'View': {},
	'Items': {},
	'List': {},
	'Add item': {},
	'Option {0}': {},
	'One under another': {},
	'Text input': {},
	'Time period': {},
	'Initial': {},
	'Placeholder': {},
	'Contains': {},
	'Begins with': {},
	'Ends with': {},
	'Slider': {},
	'Min': {},
	'Max': {},
	'Step': {},
	'An item for all': {},
	'When on': {},
	'When off': {},
	'On at first': {},
	'Equal': {},
	'Not equal': {},
	'There is no variable while it has no name': {},
	'Conditional styles': {},
	'Series color': {},
	'Choose color...': {},
	'Reset color': {},
	'Colors': {},
	'Colors by value': {},
	'Add color': {},
	'Remove color': {},
	'{0} (not in the data)': {},
	'Holds now': {},
	"Doesn't hold now": {},
	'Loading...': {},
	'It is used {0} times; those uses go with it.': {},
	'is': {},
	'On the dashboard': {},
	'Catalog': {},
	'Not used': {},
	'Used {0} times': {},
	'Used {0} more times on the dashboard. Changes apply there too.': {},
	'Edit a copy': {},
	'{0} (copy)': {},
	'Zoom': {},
	'Reset zoom': {},
	'Edit': {},
	'Delete the datasource?': {},
	'It is used {0} times; those uses are left without it.': {},
	'Drag a datasource from the catalog onto the canvas': {},
	'Mixed': {},
	'Align': {},
	'Align left': {},
	'Align horizontal centers': {},
	'Align right': {},
	'Align top': {},
	'Align vertical centers': {},
	'Align bottom': {},
	'Distribute horizontal spacing': {},
	'Distribute vertical spacing': {},
	'Library': {},
	'Templates': {},
	'Template {0}': {},
	'Save as template': {},
	'Rename template': {},
	'Rename': {},
	'Delete the template?': {},
	'Select elements on the canvas and save them with “Save as template”': {},
	'Advanced': {},
	'Apply': {},
	'Add interaction': {},
	'Delete interaction': {},
	'Hide dependents': {},
	'Show dependents': {},
	'Interaction': {},
	'True': {},
	'False': {},
	'Close': {},
	'Expand on top': {},
	'On click, the target takes the place of the element the arrow comes from, on top of it, until it is closed': {},
	'Show arrow in view mode': {},
	'Shows the arrow in view mode too. Not available with Expand on top': {},
	'Show only if': {},
	'On click the target widget will be shown': {},
	'in place': {},
	'overlay source widget': {},
	'only if {0}': {},
	'if {0}': {},
	'Chains': {},
	'No chains': {},
	'Select an element to see its chains': {},
	'On click': {},
	'Drill down': {},
	'Set variable': {},
	'Nothing': {},
	'Own variable': {},
	'Value from': {},
	'Size': {},
	'Small': {},
	'Medium': {},
	'Large': {},
	'Open': {},
	'Replace current widget': {},
	'Open new widget': {},
	'No further data': {},
	'If': {},
	'Then': {},
	'Checkboxes': {},
	'Multiple selection': {},
	'Contains any of': {},
	'Contains none of': {},
	'Export': {},
	'Used by': {},
	'Form entry': {},
	'Fancy': {},
	'Image': {},
	'Choose an image': {},
	'Choose an image in Properties': {},
	'Fit': {},
	'Fill': {},
	'Stretch': {},
	'Hide element': {},
};
